module.exports = __webpack_public_path__ + "static/media/Galdisa_SnowWhitePumpkinSeeds.689173e5.pdf";